import apiClient from "../auth/apiClient";

class LPRSearchService {
	constructor(client) {
		this.apiClient = client;
	}

	async searchLPRReads(params, cancelToken) {
		return this.apiClient.post("lpr-activity/search", {
			entityID: params.entityID,
			startDateTime: params.startDateTime,
			endDateTime: params.endDateTime,
			deviceIDs: params.deviceIDs,
			plateText: params.plateText,
			limit: params.limit,
			offset: params.offset,
		}, { cancelToken });
	}

	async getCaptureImage(lprId) {
		return this.apiClient.get(`reads/${lprId}/captureimage`, {
			responseType: "blob",
		});
	}

	async getContextImage(lprId) {
		return this.apiClient.get(`reads/${lprId}/contextimage`, {
			responseType: "blob",
		});
	}
}

export default LPRSearchService;

export const lprSearchServiceInstance = new LPRSearchService(apiClient);
